import { z } from 'zod';

export const featureFlagsVersionType = z.enum(['v1', 'v2', 'unknown']);

export const FeatureFlags = z.object({
  comment: z.boolean(),
  sharingGroup: z.boolean(),
  revisionListener: z.boolean(),
  sharingProject: z.boolean(),
  workflow: z.boolean(),
});

export const FeatureFlagsModel = z.object({
  features: FeatureFlags.partial(),
  version: featureFlagsVersionType,
});
